export const teamMembers = [
  {
    id: "team-1",
    name: "林婉清",
    title: "首席性治疗师",
    credentials: "国家二级心理咨询师 | AASECT认证性治疗师",
    experience: "15年临床经验",
    specialty: ["亲密关系咨询", "女性性功能障碍", "性心理创伤修复"],
    bio: "林婉清老师是国内最早一批获得国际性治疗师认证的专业人士。她以温暖、包容的咨询风格著称，擅长帮助来访者在安全的环境中探索和处理最私密的情感与身体议题。曾多次受邀在学术会议和媒体平台分享性健康教育的专业知识。",
    imageSeq: "team-lin-wanqing",
  },
  {
    id: "team-2",
    name: "陈博文",
    title: "医学顾问 | 男科专家",
    credentials: "医学博士 | 三甲医院泌尿男科副主任医师",
    experience: "18年临床经验",
    specialty: ["男性性功能障碍", "性传播疾病", "前列腺健康"],
    bio: "陈博文博士在男科与性医学领域深耕近二十年，将严谨的医学知识与人性化的沟通方式完美结合。他善于用通俗易懂的语言解释复杂的医学问题，帮助男性来访者克服对就医的心理障碍，找到最适合自己的健康方案。",
    imageSeq: "team-chen-bowen",
  },
  {
    id: "team-3",
    name: "苏雨桐",
    title: "家庭治疗师 | 青少年心理专家",
    credentials: "应用心理学硕士 | 注册系统家庭治疗师",
    experience: "12年临床经验",
    specialty: ["婚姻家庭咨询", "青少年性教育", "亲子关系修复"],
    bio: "苏雨桐老师专注于家庭系统和青少年发展领域，擅长处理婚姻中的亲密关系问题和青少年性心理发展困惑。她相信每个家庭都有自我修复的力量，咨询师的角色是帮助家庭成员重新找到彼此的连接。",
    imageSeq: "team-su-yutong",
  },
  {
    id: "team-4",
    name: "周明远",
    title: "高级心理咨询师",
    credentials: "临床心理学博士 | 注册系统心理咨询师",
    experience: "10年临床经验",
    specialty: ["性焦虑与强迫", "性取向认同", "创伤后心理重建"],
    bio: "周明远博士在性心理学和认知行为治疗领域有着深入的研究和丰富的实践经验。他擅长运用正念疗法和CBT技术，帮助来访者打破负面思维循环，重建与身体和欲望的健康关系。",
    imageSeq: "team-zhou-mingyuan",
  },
];